var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeautyEarthandPlanetElements08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1e2220;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.82px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.47,42.99s-16.19,1.14-11.32,16.86c0,0,14.29-.5,11.32-16.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.35,67.77s-12.78,10.01.06,20.31c0,0,11.57-8.42-.06-20.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.65,98.76s-15.84-3.55-15.67,12.91c0,0,13.84,3.62,15.67-12.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m160.06,119.79s.91-16.21-15.3-13.35c0,0-1.31,14.24,15.3,13.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m119.61,72.64s-6.81,14.74,9.32,18.04c0,0,6.46-12.76-9.32-18.04Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m101.65,37.26s-13.54,8.95-1.58,20.25c0,0,12.21-7.45,1.58-20.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m138.04,37.14s-14.47-7.36-18.39,8.62c0,0,12.51,6.94,18.39-8.62Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.59,67.67s3.27,15.9,18.21,8.99c0,0-2.39-14.1-18.21-8.99Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89,33.95v127.99"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.19,56.05c.5,1.04,15.82,42.86,50.77,51.19"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.08,56.05s8.47,18.35,8.46,45.89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.6,93.81s-19.93,6.36-42.18-7.71"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m92.24,117.11s45.79-6.66,47.48-47.29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.99,71.62s-16.64,17.62-1.58,40.63"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.9,105.72s24.66,6.53,37.93-12.26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.21,60.59s29.64,7.12,26.87-26.86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyEarthandPlanetElements08);
export default __webpack_public_path__ + "static/media/Beauty, Earth and Planet Elements-08.a80931bb62872a91a8977d7e5a14b054.svg";
export { ForwardRef as ReactComponent };